export enum ViewFiltersMode {
  REALISTIC = 'realistic',
  ACCURE_SOC = 'accure_soc',
  BMS_SOC = 'bms_soc',
  SOC_OFFSET = 'soc_offset',
  ALERT_STATUS = 'alert_status',
  IMBALANCE_SOC = 'imbalance_soc',
  TEMPERATURE = 'temperature',
}

export type ViewFilters = {
  viewMode: ViewFiltersMode;
  accureSoc: { min: number; max: number };
  bmsSoc: { min: number; max: number };
  imbalanceSoc: { min: number; max: number };
  temperature: { min: number; max: number };
};
